import apiClient from "@/api/client";

export default {
  fetchParts() {
    return apiClient.get("/parts");
  },
};
